export const LOADING_STATUSES = {
  FAILURE: 'failure',
  INITIAL: 'initial',
  LOADING: 'loading',
  SUCCESS: 'success',
};
